import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
import { grid } from '@finect/tabular-utils/grid';

export const Article = styled.article`
  position: relative;
  padding: 48px 0 0;
  ${getFont(1)};

  ${maxMediaQueries.tablet`
    padding: 30px 0 0;
  `};

  img {
    max-width: ${grid(7)}px;
    margin: 0 auto 42px;
    display: block;

    ${maxMediaQueries.miniDesktop`
      max-width: ${grid(6)}px;
    `}

    ${maxMediaQueries.tablet`
      max-width: ${grid(4)}px;
      margin-bottom: 30px;
    `}

    ${maxMediaQueries.phone`
      max-width: ${grid(3)}px;
      margin-bottom: 24px;
    `}
  }

  /* stylelint-disable */
  h1 {
    display: block;
    position: relative;
    max-width: ${grid(6)}px;
    padding-bottom: 0 !important;
    padding-left: 30px;
    margin: 0 auto 42px;

    ${maxMediaQueries.miniDesktop`
      padding-left: 21px;
    `};

    &:after {
      position: absolute;
      top: 3px;
      bottom: -3px;
      left: 0;
      border: 2.5px solid #3c44d7;
      border-radius: 2.5px;
      content: '';
      background-color: #3c44d7;
    }
  }
  /* stylelint-enable */

  h3 {
    display: block;
    max-width: ${grid(6)}px;
    margin: 30px auto 9px;
  }

  h4 {
    display: block;
    max-width: ${grid(6)}px;
    margin: 24px auto 9px;
  }

  p {
    margin: 0 auto;
  }

  > section {
    max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}` : '666px')};
    margin: 0 auto;

    > h2 {
      display: block;
      margin-bottom: 24px;
    }

    hr {
      margin: 48px auto;
      border: 0;
      border-top: 1px solid ${({ theme }) => theme.colors.uiL};
    }

    + section {
      padding-top: 27px;
    }
  }

  > a,
  h4 a {
    border-bottom: 3px solid ${({ theme }) => theme.colors.uiL};
    color: ${({ theme }) => theme.linkColor};
    transition: background-color 0.25s ease;

    &:hover {
      background-color: ${({ theme }) => theme.colors.uiL};
    }
  }

  ul > li,
  ol > li {
    max-width: ${grid(6)}px;
    margin: 0 auto;
  }

  ul > li {
    padding-bottom: 15px;
  }

  ol > li {
    padding-bottom: 24px;
  }

  ul {
    margin-top: 24px;
  }

  ${maxMediaQueries.phone`
    ${getFont(0)};

    p {
      ${getFont(0)};
    }
  `};
`;
